<script>
    import { onMount } from "svelte";
    import { api_get } from "../util/api_request"
    import ServerStatus from "../include/ServerStatus.svelte";

    let server_status;

    onMount(async () => {
        server_status = await api_get("/api/server_status")
        .then(res => res.data);
    })
</script>

<div class="header">
    <h1 class="header-title">Welcome to gitsmok <span class="super">web</span></h1>
    <p class="header-text">
        Welcome to the most based survival multiplayer server,
        now running version {server_status ? server_status.version : "?"}!
    </p>
    {#if server_status}
        <ServerStatus status={server_status} />
    {/if}
</div>

<div class="content">
    <div class="container">
        <h2>Register with your discord account and get whitelisted here:</h2>
        <a href="/login" tinro-ignore><button class="btn blue">Log in with discord</button></a>
        <a href="/whitelist"><button class="btn blue">Get whitelisted</button></a>
    </div>
</div>

<style>
    /* HEADER */

    .header {
        padding: 100px 15px;
    }

    .header-title {
        font-size: 80px;
        text-align: center;
        background: -webkit-linear-gradient(277deg, #372050, #6eb8bf);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .header-text {
        font-size: 18px;
        text-align: center;
    }

    .header-buttons button {
        margin: 10px 20px;
    }

    span.super {
        font-size: 40px;
    }
</style>